import {t} from '@lingui/core/macro';

import {dateFilterKeys} from 'shared/lib/filterHelper';

import {UserReportPeriod} from '../model/UserReport/IUserReport';

export const USER_REPORT_PERIODS: UserReportPeriod[] = ['W', 'M', 'Y'];

export const USER_REPORT_FILTER_KEYS = [
    'is_active',
    'period',
    ...dateFilterKeys('created_at'),
    ...dateFilterKeys('last_sent_at'),
];

export function getUserReportPeriodLabel(period: UserReportPeriod): string {
    switch (period) {
        case 'W':
            return t`Раз в неделю`;
        case 'Y':
            return t`Раз в год`;
        case 'M':
        default:
            return t`Раз в месяц`;
    }
}
